import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
	width: 100vw;
	height: 75vh;
	overflow: hidden;
	text-align: center;
`;
